export class Project {
    public id: string = "";
    public name: string = "";
    public code: string = "";
}

